import { Directus } from '@directus/sdk';
import { API_POLICY_FIELDS } from './fields';
import PolicySection from './models/PolicySection';
import { PolicyType } from './response/PolicyResponse';
export default class PoliciesApi {
    static getInstance(basePath) {
        if (this.instance)
            return this.instance;
        if (!basePath) {
            basePath = process.env.CMS_URL;
        }
        const instance = new PoliciesApi();
        instance.api = new Directus(basePath);
        return (this.instance = instance);
    }
    async getCookiePolicy(lang, policy_type) {
        var _a;
        let entity = '';
        if (policy_type == PolicyType.COOKIES_POLICY)
            entity = 'cookies_policy';
        if (policy_type == PolicyType.PRIVACY_POLICY)
            entity = 'privacy_policy';
        const response = await ((_a = this.api) === null || _a === void 0 ? void 0 : _a.items(entity).readOne(1, {
            fields: [...API_POLICY_FIELDS],
            deep: {
                translations: { _filter: { languages_code: { lang: { _eq: lang } } } }
            }
        }));
        return PolicySection.fromApi(response);
    }
}
